/**
 * Environment detection utility
 * Determines the current environment based on the hostname and environment variables
 */

export type Environment = 'development' | 'production';

/**
 * Get the current environment based on environment variables first,
 * then fallback to hostname detection
 */
export const getEnvironment = (): Environment => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // Check for production hostname
    if (hostname === 'referral.hellolunajoy.com') {
      return 'production';
    }
    
    // Check for development hostname
    if (hostname === 'referral-dev.hellolunajoy.com') {
      return 'development';
    }
  }

  // Default to development
  return 'development';
};

/**
 * Check if the current environment is production
 */
export const isProduction = (): boolean => {
  // Check if the environment is explicitly specified
  return getEnvironment() === 'production';
};

/**
 * Get appropriate URL for services based on environment
 * @param service The service name (e.g., 'booking', 'partner')
 * @param clinicCode Optional clinic code to append to the URL
 */
export const getServiceUrl = (service: 'booking' | 'partner', clinicCode?: string): string => {
  const isProd = isProduction();
  const baseUrl = isProd 
    ? `https://${service}.hellolunajoy.com`
    : `https://${service}-dev.hellolunajoy.com`;
  
  if (service === 'booking' && clinicCode) {
    return `${baseUrl}/?referal=${clinicCode}`;
  } else if (service === 'partner' && clinicCode) {
    return `${baseUrl}/${clinicCode}`;
  }
  
  return baseUrl;
}; 